import React from "react";
import PropTypes from "prop-types";
import { RPMBlock } from "./RPMBlock";
import { TimerBlock } from "./TimerBlock";
import { PulseButton } from "./PulseButton";
import { DisplayDivider } from "./DisplayDivider";

import "./style.scss";

/**
 * Settings:
 *    renders the settings part of centrifuge front view
 *  (including display and buttons)
 */

export function Settings(props) {
  return (
    <div className="mc_settings">
      <div className="mc_settings_displayBlock">
        <RPMBlock value={props.data.rpmValue} setRPM={props.setRPM} />
        <DisplayDivider className="mc_settings_displayBlock_divider" />
        <TimerBlock
          value={props.data.timerValue}
          setTimer={props.setTimer}
          onRunCentrifuge={props.onRunCentrifuge}
          onStopCentrifuge={props.onStopCentrifuge}
        />
      </div>
      <PulseButton
        className="mc_settings_pulseButton"
        setTimer={props.setTimer}
        onRunCentrifuge={props.onRunCentrifuge}
      />
    </div>
  );
}

Settings.propTypes = {
  /**
   * data for setings
   */
  data: PropTypes.shape({
    /**
     * value for rpm
     */
    rpmValue: PropTypes.number,
    /**
     * value for timer
     */
    timerValue: PropTypes.instanceOf(Date),
  }),
  /**
   * callback function to run centrifuge
   */
  onRunCentrifuge: PropTypes.func,
  /**
   * callback function to stop centrifuge
   */
  onStopCentrifuge: PropTypes.func,
  /**
   * callback function to set rpm value
   */
  setRPM: PropTypes.func,
  /**
   * callback function to set timer value
   */
  setTimer: PropTypes.func,
};

Settings.defaultProps = {};
